module.exports = __webpack_public_path__ + "img/title_bg_deyu_860.b159f154.png";